import React, { useState } from 'react';
import CreativeDesignModal from '../../Creative-Community/CreativeDesignModal/CreativeDesignModal';
import CommunityImg from '../CommunityImg/CommunityImg';
import './DesignCard.scss';

const DesignCard = ({
  designs,
  isModal = false,
  isCreativeList = false,
  limit = designs.length
}) => {

  const [isOpen, setIsOpen] = useState(false);
  const [selectedDesign, setSelectedDesign] = useState(null);

  const onDesignCardClick = (designItem) => {
    if (isCreativeList) {
      setSelectedDesign(designItem);
      setIsOpen(true);
    }
  }

  const openCustomiseMe = (design) => {
    const [productType] = design.productType;
    let url = '';
    let hostNameStr = window.location.hostname === 'localhost' ? 'noissue.co' : window.location.hostname;
    switch (productType) {
      case "Card":
        url = `https://www.${hostNameStr}/custom-packaging/custom-cards/design-online`;
        break;
      case "Kraft Mailer":
        url = `https://www.${hostNameStr}/custom-packaging/custom-kraft-mailers/design-online`;
        break;
      case 'Stamp':
        url = `https://www.${hostNameStr}/custom-packaging/custom-stamps/design-online/`;
        break;
      default:
        break;
    }
    window.open(url, '_blank', 'noopener');
  }

  return (
    <>
      {
        [...designs]
        .splice(0, limit)
        .map((design, idx) => {
          return <div key={`design-${idx}`} className="design-item">
            <div className="kg-card kg-image-card">
              <CommunityImg src={design?.designsFiles ? design?.designsFiles[0]?.file?.url : ''} alt='designs' />
            </div>

            <div className="design-content">
              <div className="design-heading"> {design.designTitle} </div>
              {/* <div className="design-sub-heading"> from $75NZ (+ GST) </div> */}
              <div className="design-buttons">
                <button onClick={() => openCustomiseMe(design) }> Customize Design </button>
                <button className="check-me-out" onClick={() => onDesignCardClick(design)}> View Design </button>
              </div>
              {
                !isModal && design?.designerProfile && 
                <div className="design-author-container">
                  <div className="design-author-pic" style={{ backgroundImage: `url(${design?.designerProfile?.partnerLogo?.file.url})` }} />
                  <div className="design-author-detail ">
                    {design?.designerProfile && <div className="design-author-title">by {design?.designerProfile?.partnerName}</div>}
                    <div className="design-author-location">{design?.designerProfile?.partnerCountry}</div>
                  </div>
                </div>
              }
            </div>
          </div>
        })
      }
      {
        isOpen && selectedDesign &&
        <CreativeDesignModal selectedDesign={selectedDesign} onClose={() => setIsOpen(false)} isOpen={isOpen} />
      }
    </>
  )
}

export default DesignCard;